import React from 'react';
import {handleReturnInforErrorResponse, InforErrorObj} from "./errorUtils";
import {notifications} from "@mantine/notifications";

/**
 * Shows a Mantine notifications alert with a red error banner when an API request fails, displaying the parsed error message and details from the InforErrorObj.
 */
export default function errorResponse(val: InforErrorObj) {
    const response = handleReturnInforErrorResponse(val);
    const title = "There was a problem completing the requested action";
    const message = (
        <>
            {response.error}
            <br />
            {response.details.map((d) => (
                <p key={d}>{d}</p>
            ))}
        </>
    );

    //@ts-ignore
    notifications.show({
        color: "red",
        title: title,
        message: message,
        autoClose: false,
    })
}
